<template>
    <div class="dropdown-filter">
        <div class="filter-container">
            <AonDropdown
                :key="updater"
                :items="options"
                :init-selection="initSelection"
                :data-cy="`filter.dropdown`"
                show-clear
                width="100%"
                placeholder-trigger-color
                :checkbox="checkbox"
                @select-cleared="onFilter({ itemValue: null })"
                @select-option="onFilter"
                @all-selected-options="onMultiFilter"
            />
        </div>
    </div>
</template>

<script>
import { debounce, capitalize } from 'lodash-es';
import AonDropdown from '@moatmetrics/armory/src/components/base/forms/AonDropdown.vue';

export default {
    name: 'DropDownFilter',
    components: {
        AonDropdown,
    },
    props: {
        columnName: {
            type: String,
            default: '',
        },
        filterState: {
            type: Object,
            default: () => {},
        },
        columnLabel: {
            type: String,
            default: '',
        },
        // Array of objects
        // EX: { itemText: 'One', itemValue: 'one' },
        options: {
            type: Array,
            default: () => [],
        },
        checkbox: {
            type: Boolean,
            default: false,
        },
        filterVariant: {
            type: String,
            default: 'word match'
        },
        useItemTextForDisplay: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            filterValue: null,
            filterDisplay: null,
            filterType: this.filterVariant,
            filterText: 'Dropdown Filter',
            updater: 0,
        };
    },
    computed: {
        detail() {
            return {
                filterColumn: this.columnName,
                filterValue: this.filterValue,
                filterType: this.filterType,
                filterLabel: this.columnLabel,
                filterDisplay: this.filterDisplay,
                filter: 'dropdown',
            };
        },
        capFilterType() {
            return capitalize(this.filterType);
        },
        initSelection() {
            if (this.filterValue) {
                return {
                    itemText: this.filterValue,
                    itemValue: this.filterValue,
                };
            }
            return null;
        },
    },
    watch: {
        filterState: {
            handler() {
                this.setupFilters();
            },
            deep: true,
        },
    },
    beforeMount() {
        this.setupFilters();
    },
    methods: {
        setupFilters() {
            if (!this.filterState) {
                this.clearFilter();

                return;
            }

            this.setFilter();
        },
        onFilter: debounce(function (val) {
            if (!this.checkbox) {
                this.filterValue = val.itemValue;
                if(this.useItemTextForDisplay) {
                    this.filterDisplay = val.itemText
                }
                this.$emit('onFilter', this.detail);
            }
        }, 500),
        onMultiFilter: debounce(function (vals) {
            if (this.checkbox) {
                this.filterValue = vals.map((x) => x.itemValue).join(' OR ');
                if(this.useItemTextForDisplay) {
                    this.filterDisplay = vals.map((x) => x.itemText).join(' OR ')
                }
                this.$emit('onFilter', this.detail);
            }
        }, 500),
        clearFilter() {
            if (this.filterValue) {
                this.updater++;
            }
            this.filterValue = null;
        },
        setFilter() {
            this.filterValue = null;

            this.filterValue = this.filterState.filterValue;
        },
    },
};
</script>

<style lang="scss">
.dropdown-filter {
    width: 100%;

    .aon-dropdown .trigger.border {
        border-color: $grey01 !important;
    }

    .filter-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        li {
            text-align: left;
        }
    }

    .type-selection-container {
        width: calc(100% - 20px);
        display: flex;
        justify-content: left;
        align-items: center;
        padding-bottom: 8px;

        .filter-type {
            font-size: 10px;
            color: $grey04;
            padding: 4px 10px 0px 5px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .aon-dropdown .svg-inline--fa {
        vertical-align: 0.1em;
    }

    .aon-dropdown .trigger p {
        text-align: left;
    }
}
</style>
